import { useState } from 'react';
import { Checkbox } from 'antd';
import CommonModal from '../../components/Modal';
import Alert from '../../components/Alert';
import { useTranslation } from 'react-i18next';

interface ReleaseCampaignModalProps {
    visible: boolean;
    onClose: () => void;
    onRelease: () => void;
    userCount: number;
}

const ReleaseCampaignModal = ({
    visible,
    onClose,
    onRelease,
    userCount,
}: ReleaseCampaignModalProps) => {
    const [testEmailConfirmed, setTestEmailConfirmed] = useState(false);
    const { t } = useTranslation();

    const handleRelease = () => {
        if (testEmailConfirmed) onRelease();
    };

    return (
        <CommonModal
            visible={visible}
            modalTitle={t('phishingManager.releaseCampaignModal.title')}
            confirmText={t('phishingManager.releaseCampaignModal.confirmText')}
            cancelText={t('phishingManager.releaseCampaignModal.cancelText')}
            iconType={null}
            showConfirmBtn={true}
            confirmBtnDisabled={!testEmailConfirmed}
            onClose={onClose}
            onConfirm={handleRelease}
            parentClass='pm-release-modal'
        >
            <>
                <p className="pm-release-description">
                    {t('phishingManager.releaseCampaignModal.description')}
                </p>

                <div className="alert-section">
                    <Alert
                        subtitle={t('phishingManager.releaseCampaignModal.alert.subtitle')}
                    />
                </div>

                <div className="pm-release-checkbox-row">
                    <Checkbox
                        checked={testEmailConfirmed}
                        onChange={(e) => setTestEmailConfirmed(e.target.checked)}
                    >
                        <span className="pm-release-checkbox-label">
                            {t('phishingManager.releaseCampaignModal.checkbox.label')}
                        </span>
                    </Checkbox>
                </div>
            </>
        </CommonModal>
    );
};

export default ReleaseCampaignModal;